import React, { useState } from 'react';
import { Navbar, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { User } from 'react-feather';
import { logout } from '../utils/functions';
import { getAuth } from "firebase/auth";
import { useTranslation } from 'react-i18next';
import './NavMenu.css';

const NavMenu = () => {
  const auth = getAuth();
  const [loggedInUserEmail, setLoggedInUserEmail] = useState(auth.currentUser?.email || '');
  const navigator = useNavigate();
  const { t } = useTranslation();
  return (
    <header>
      <Navbar className="navbar-expand-sm background-white mb-3 d-flex flex-end" light fluid>
        <ul className="navbar-nav flex-grow ms-auto">
          <UncontrolledDropdown nav className="ml-auto d-flex align-items-center custom-profile">
            <User size={16} className="me-3"/>
            <DropdownToggle nav className="link-header-admin nav-link text-lowercase custom-dropdown-toggle">
              {loggedInUserEmail}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => navigator('/admin/profile')}>
                {t("Profile")}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={() => logout().then(() => navigator('/'))}>
                {t("Logout")}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </ul>
      </Navbar>
    </header>
  );
};

export default NavMenu;
